<button type='button' class='btn btn-sm btn-outline-danger' (click)="resetFilterData()">
	Reset Filters
</button>
